const genericToastSettings = {
    action: {
        icon: 'fa-times',
        // eslint-disable-next-line no-undef
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        },
    },
    duration: 5000,
    containerClass: 'toasts-container',
};

/**
 * Prepares toast message
 *
 * @param {object} payload Toast message
 *
 * @returns {string} Toast message
 */
export const toastMessageContainer = (payload) => {
    if (! payload.message.content) {
        return `<div><span class="toast-title">${payload.message.title}</span></div>`;
    }

    return `<div><span class="toast-title">${payload.message.title}</span><span class="toast-content">${payload.message.content}</span></div>`;
};

export const toastSuccess = {
    ...genericToastSettings,
    className: 'toast-success',
    icon: 'fa-check',
};

export const toastInfo = {
    ...genericToastSettings,
    className: 'toast-info',
    icon: 'fa-exclamation',
};

export const toastError = {
    ...genericToastSettings,
    className: 'toast-error',
    icon: 'fa-times',
};

export const toastMessage = {
    ...genericToastSettings,
    className: 'toast-message',
    icon: 'fa-info',
};
